import { AmountPrice } from '@app/sales/models/price.model';
import { EquipmentPrice } from '@app/sales/modules/mobilephone/models/equipment-upgrade-agreement.model';
import { Price } from '@app/shared/models/price.model';
import { PriceType } from '@app/shared/pipes/price-format.pipe';

export const mapAmountPriceToPrice = (amountPrice: AmountPrice) =>
  new Price(amountPrice.amountIncludingVAT, amountPrice.amountExcludingVAT, amountPrice.vatPercentage);
export const mapPriceToAmountPrice = (amountPrice: Price): AmountPrice => {
  return {
    amountIncludingVAT: amountPrice.includingVAT,
    amountExcludingVAT: amountPrice.excludingVAT,
    vatPercentage: amountPrice.vatPercentage,
  } as AmountPrice;
};

function isPriceObj(price: Price | number | AmountPrice | EquipmentPrice): price is Price {
  return (price as Price).includingVAT !== undefined;
}

function isAmountPriceObj(price: Price | number | AmountPrice | EquipmentPrice): price is AmountPrice {
  return (price as AmountPrice).amountIncludingVAT !== undefined;
}

function isEquipmentPrice(price: Price | number | EquipmentPrice | AmountPrice): price is EquipmentPrice {
  return (price as EquipmentPrice).includingVat !== undefined;
}

function formatPrice(price: number): string {
  return (Math.round(price * 100) / 100)
    .toFixed(2)
    .replace('.', ',')
    .replace(/[.,]00$/, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
}

export function transformPrice(
  price: AmountPrice | Price | number | EquipmentPrice,
  priceType: PriceType,
  priceIsZeroText?: string
): string {
  if (!price) {
    if (priceIsZeroText) return priceIsZeroText;
    if (priceType === PriceType.Monthly) return '0\u00A0kr/mnd';
    return '0\u00A0kr';
  }

  if (isAmountPriceObj(price)) {
    price = {
      includingVAT: price.amountIncludingVAT,
      excludingVAT: price.amountExcludingVAT,
      vatPercentage: price.vatPercentage,
    } as Price;
  }

  if (isEquipmentPrice(price)) {
    price = {
      includingVAT: price.includingVat,
      excludingVAT: price.excludingVat,
      vatPercentage: price.vatPercentage,
    } as Price;
  }

  if (isPriceObj(price)) {
    const priceIncludingVATWithTwoDecimals = !price.includingVAT ? '0' : formatPrice(price.includingVAT);
    switch (priceType) {
      case PriceType.Monthly:
        return `${priceIncludingVATWithTwoDecimals}\u00A0kr/mnd`;
      default:
        return `${priceIncludingVATWithTwoDecimals}\u00A0kr`;
    }
  } else {
    const priceWithTwoDecimals = formatPrice(price);
    switch (priceType) {
      case PriceType.Monthly:
        return `${priceWithTwoDecimals}\u00A0kr/mnd`;
      default:
        return `${priceWithTwoDecimals}\u00A0kr`;
    }
  }
}
